import { lightTheme } from '@arcadiapower/shrike';
import { useState, useLayoutEffect } from 'react';
import { Caption, Container, Image as StyledImage, ResponsiveImage } from './image.style';

type ImageProps = {
  altText: string;
  caption?: string;
  maxWidth?: string;
  source: string | { desktop: string; mobile: string };
};

export const Image = ({ altText, caption, source, maxWidth }: ImageProps) => {
  const [showMobile, setShowMobile] = useState(true);

  useLayoutEffect(() => {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
    const mql = window.matchMedia(`(max-width: ${lightTheme.breakpoints.tabletPortrait}px)`);
    setShowMobile(mql.matches);

    const onChange = (event: MediaQueryListEvent) => setShowMobile(event.matches);

    mql.addEventListener('change', onChange);

    return () => mql.removeEventListener('change', onChange);
  }, []);

  if (maxWidth && typeof source === 'string') {
    return (
      <Container>
        <ResponsiveImage src={source} alt={altText} maxWidth={maxWidth} />
        {caption ? <Caption>{caption}</Caption> : null}
      </Container>
    );
  }

  if (typeof source === 'string') {
    return (
      <Container>
        <StyledImage src={source} alt={altText} />
        {caption ? <Caption>{caption}</Caption> : null}
      </Container>
    );
  }

  const src = showMobile ? source.mobile : source.desktop;

  return (
    <Container>
      <StyledImage src={src} alt={altText} />
      {caption ? <Caption>{caption}</Caption> : null}
    </Container>
  );
};
